import { composeClassNames, ifDefined } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import ContactsInModal from "src/components/ContactsInModal";
import Translate from "src/components/Translate";
import constants from "src/constants";
import Facebook from "src/icons/Facebook";
import Instagram from "src/icons/Instagram";
import Pin from "src/icons/Pin";
import Web from "src/icons/Web";
import Youtube from "src/icons/Youtube";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import { ApiAddress } from "src/types/ApiAddress";
import { ApiContact } from "src/types/ApiContact";
import { ApiSites } from "src/types/ApiSites";
import { VariantProfileType } from "src/types/VariantProfileType";

type Props = {
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
  data: {
    sites: ApiSites;
    address?: ApiAddress;
    contact?: {
      nickname: string;
      profileType: VariantProfileType;
      contacts: ApiContact[];
    };
  };
};

function ProfileButtons({ className, style, data }: Props) {
  return (
    <div
      style={style}
      className={composeClassNames([sButtons, className, "profile-buttons"])}
    >
      {ifDefined(
        data.sites.facebook,
        (value) => (
          <Button
            as="a"
            variant="outline-primary"
            className={composeClassNames([sButton, "btn-icon-before"])}
            href={value + constants.Paths.partnerParam}
            target="_blank"
          >
            <Facebook />
            <Translate tKey={`Facebook`} />
          </Button>
        ),
        () => null
      )}
      {ifDefined(
        data.sites.instagram,
        (value) => (
          <Button
            as="a"
            variant="outline-primary"
            className={composeClassNames([sButton, "btn-icon-before"])}
            href={value + constants.Paths.partnerParam}
            target="_blank"
          >
            <Instagram />
            <Translate tKey={`Instagram`} />
          </Button>
        ),
        () => null
      )}
      {ifDefined(
        data.sites.youtube,
        (value) => (
          <Button
            as="a"
            variant="outline-primary"
            className={composeClassNames([sButton, "btn-icon-before"])}
            href={value + constants.Paths.partnerParam}
            target="_blank"
          >
            <Youtube />
            <Translate tKey={`YouTube`} />
          </Button>
        ),
        () => null
      )}
      {ifDefined(
        data.sites.website,
        (value) =>
          data.sites.website.length > 0 ? (
            <Button
              as="a"
              variant="outline-primary"
              className={composeClassNames([sButton, "btn-icon-before"])}
              href={value + constants.Paths.partnerParam}
              target="_blank"
            >
              <Web />
              <Translate tKey={`Website`} />
            </Button>
          ) : null,
        () => null
      )}
      {ifDefined(
        data.address,
        (value) =>
          data.address.city ? (
            <Button
              as="a"
              variant="outline-primary"
              className={composeClassNames([sButton, "btn-icon-before"])}
              href={
                `https://www.google.com/maps/search/` +
                value.place +
                `, ` +
                value.city +
                `, ` +
                value.street +
                `, ` +
                value.zip
              }
              target="_blank"
            >
              <Pin />
              <Translate tKey={`Location on the map`} />
            </Button>
          ) : null,
        () => null
      )}
      {data?.contact && <ContactsInModal data={data.contact} />}
    </div>
  );
}

export default ProfileButtons;
